import { resolveProductImageDisplayUrl, toBooleanFromBit } from '../../product/utils/productHelpers';

export const resolveBannerImageUrl = (imageUrl) => resolveProductImageDisplayUrl(imageUrl);

export const isBannerActive = (row) => toBooleanFromBit(row?.IsActive, true);

export const sortBannerRows = (rows = []) =>
  [...rows].sort(
    (a, b) =>
      Number(a.DisplayOrder || 0) - Number(b.DisplayOrder || 0) ||
      Number(a.BannerId || 0) - Number(b.BannerId || 0),
  );

export const getNextDisplayOrder = (rows = []) => {
  if (!rows.length) return 1;
  return Math.max(...rows.map((row) => Number(row.DisplayOrder) || 0)) + 1;
};
